import type { IBaseCostGeneration } from "~/solidJs/entities/PremiumPopUp/helpers/IProducts";

export const getGenerationCountFromBaseCost = (
	credits: number,
	baseCost: IBaseCostGeneration[],
	key: IBaseCostGeneration["type"]
) => {
	return Math.ceil(credits / (baseCost.find((cost) => cost.type === key)?.cost || 1));
};
